/* eslint-disable */
/* tslint:disable */
// @ts-ignore
export default {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M0 17.508l4.23-4.231 17.508 17.508L43.77 8.754l4.23 4.23-26.262 26.262-4.23-4.23z" fill-rule="nonzero"/>'
}
